import classNames from "classnames";
import CiroButton, { CiroButtonStyleEnum } from "../../../shared/CiroButton";

interface ISuggestedPrompts {
  text: string;
  prompts: string[];
  onSelectPrompt: (prompt: string) => void;
}

const SuggestedPrompts = ({
  text,
  prompts,
  onSelectPrompt,
}: ISuggestedPrompts) => {
  return (
    <div>
      <div className={classNames("text-gray-500", "pb-4", "text-sm")}>
        {text}
      </div>
      <div
        className={classNames(
          "grid",
          "grid-cols-1",
          "sm:grid-cols-3",
          "gap-2",
          "items-start",
          "stretch",
        )}
      >
        {prompts.map((prompt) => (
          <CiroButton
            key={prompt}
            onClick={() => onSelectPrompt(prompt)}
            style={CiroButtonStyleEnum.UNSTYLED}
            customClassName={classNames(
              "rounded-lg",
              "p-3",
              "text-sm",
              "text-left",
              "transition-colors",
              "border",
              "border-gray-200",
              "text-gray-700",
              "hover:bg-gray-100",
              "focus:outline-none",
              "focus:ring-2",
              "focus:ring-orange-500",
              "focus:ring-opacity-50",
              "h-full",
            )}
            analyticsField="Selected prompt from pill"
            analyticsProps={{
              prompt,
            }}
          >
            {prompt}
          </CiroButton>
        ))}
      </div>
    </div>
  );
};

export default SuggestedPrompts;
